import { mainPathBuilder as conversation } from '@guiker/conversation-shared'
import { mainPathBuilder as investment } from '@guiker/investment-shared'

export const pathBuilder = {
  conversation,
  investment,
}
